class LicenseEmailValidation {
  constructor(input) {
    this.input = input;
    this.form = input.form;
    this.button = this.form?.querySelector('[name="add"]');
    this.error = input.parentElement.querySelector('[data-license-email-error]');

    if (!this.form || !this.button || !this.error) return;

    this.input.addEventListener('input', () => this.update());
    this.input.addEventListener('blur', () => this.update());
    this.form.addEventListener('submit', (event) => {
      if (!this.input.validity.valid) {
        event.preventDefault();
        this.update();
        this.input.focus();
      }
    });
    new MutationObserver(() => {
      if (!this.input.validity.valid && !this.button.disabled) this.update();
    }).observe(this.button, { attributes: true, attributeFilter: ['disabled'] });

    this.update();
  }

  update() {
    const valid = this.input.validity.valid;
    const variantUnavailable = this.form.querySelector('.product-variant-id')?.disabled;

    this.error.hidden = valid;
    this.error.textContent = valid ? '' : 'Enter a valid license email address.';
    this.button.toggleAttribute('disabled', !valid || variantUnavailable);
    this.button.setAttribute('aria-disabled', String(!valid || variantUnavailable));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-license-email]').forEach((input) => new LicenseEmailValidation(input));
});